export enum ImmunizationAdministererEnum {
  Clinic = 1,
  Pharmacist = 2,
  PhysicianOffice = 3,
  SkilledNurse = 4,
  Other = 99
}

export const ImmunizationAdministererOptions = [
{ id: 1, label: 'Clinic' },
{ id: 2, label: 'Pharmacist' },
{ id: 3, label: 'Physician Office' },
{ id: 4, label: 'Skilled Nurse' },
{ id: 99, label: 'Other' }
];
